export default "__VITE_ASSET__RttRpR7u__"